import { render } from "./postUpdateOrSave.vue?vue&type=template&id=7588328c"
import script from "./postUpdateOrSave.vue?vue&type=script&lang=js"
export * from "./postUpdateOrSave.vue?vue&type=script&lang=js"
script.render = render

export default script